// extracted by mini-css-extract-plugin
export default {"loading":"loading_loading__Z7+iF","light":"loading_light__Sgn4Z","blink":"loading_blink__9u+Ji"};